import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { MessageSquare } from 'lucide-react';
import FeedbackForm from './FeedbackForm';

const FeedbackButton = ({ className }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const [isFormOpen, setIsFormOpen] = useState(false);
  
  return (
    <>
      <button
        onClick={() => setIsFormOpen(true)}
        className={`flex items-center p-2 rounded-lg transition-colors ${
          isDark 
            ? 'hover:bg-gray-700 text-gray-200' 
            : 'hover:bg-gray-100 text-gray-800'
        } ${className || ''}`}
        aria-label={t('standaloneDashboard.feedback')}
      >
        <MessageSquare className="h-5 w-5 mr-3 text-amber-600 dark:text-amber-400" />
        <span className="text-sm">{t('standaloneDashboard.feedback')}</span>
      </button>
      
      {isFormOpen && (
        <FeedbackForm 
          isOpen={isFormOpen} 
          onClose={() => setIsFormOpen(false)} 
        />
      )}
    </>
  );
};

export default FeedbackButton;